export const DashboardSettingsBillingFeatureMapping = {
  FreePlan: [
    'Up to 2 Journeys',
    'Unlimited Journey Views',
    'Unlimited Content',
    'Email Notifications',
    'Customize Journey styling to reflect your organisation branding and logo',
    'Anonymous Insights of who viewed what Journey',
    'Send Journey activity data to Zapier',
    'Capture viewer emails',
    'Comments',
    'Video messages in email gates',
    'Google Drive Integration'
  ],
  StarterPlan: [
    'Everything in Free, plus:',
    'Up to 15 Journeys',
    'Email Notifications',
    'Clearbit enriched Insights',
    'Option to remove "Made in Journey" branding',
  ],
  ProPlan: [
    'Everything in Starter, plus:',
    'Unlimited Journeys',
    'Email & Slack Notifications',
    'Send Journey activity data to Segment and Slack',
    'Unlimited workspaces',
    'Secure Journeys with passwords, whitelists, blacklists, and email verification',
    'Create Workspaces to organize Journeys',
    'Organization templates',
    'Clay Integration',
    'Presentation mode in Journey',
    'Session Replays',
    'Advanced Analytics like pageviews, device & browser types',
  ],
  EnterprisePlan: [
    'Everything in Pro, plus:',
    'Unlimited Journeys',
    'Unlimited workspaces',
    'Hubspot Integration',
    'Gong.io Integration',
    'Custom Domain for Journeys',
    'Dedicated Support'
  ],
};
